import { isEqual } from "lodash";

export function checkDuplicateRowsInCSV (rawObject: Array<object>) {
    const uniqueObjectSet: any = new Set();
    rawObject.forEach((obj: any) => {
        let isDuplicate: boolean = false;
        for (const uniqueObj of uniqueObjectSet) {
            if (isEqual(obj, uniqueObj)) {
                isDuplicate = true;
                break;
            }
        }
        if (!isDuplicate) {
            uniqueObjectSet.add(obj);
        }
    });
    return [...uniqueObjectSet];
}